import { render, staticRenderFns } from "./DutiesHeader.vue?vue&type=template&id=472d6425&"
import script from "./DutiesHeader.vue?vue&type=script&lang=js&"
export * from "./DutiesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports